import { useMatch } from 'react-router';
import { paths } from '@/routes-utils/paths';

export const useIsTerminalRoute = () =>
  Boolean(useMatch(`${paths.terminal}/*`));
